// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brush-icon {
  font-size: 22px;
  color: #5aa0ba;
}

.wrench-icon {
  font-size: 22px;
  padding-right: 5px;
  padding-left: 5px;
  color: #5aa0ba;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
